/* nplus-leasing-service.js — endpoint resolution + leasing inquiry call.
   Classic script: exposes window.nplusLeasing. No dependencies. */
(function () {
  'use strict';

  function resolveEndpoint() {
    var host = window.location.hostname;
    var isLocal = host === 'localhost' || host === '127.0.0.1';
    if (isLocal && window.__BACKEND_BASE) {
      return window.__BACKEND_BASE.replace(/\/$/, '') + '/create-leasing-inquiry';
    }
    return '/apps/nplus-deposit/create-leasing-inquiry';
  }

  function createLeasingInquiry(payload) {
    return fetch(resolveEndpoint(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw new Error(body && body.error ? body.error : 'leasing request failed');
        return body; // { draftOrderId, customerId }
      });
    });
  }

  window.nplusLeasing = { resolveEndpoint: resolveEndpoint, createLeasingInquiry: createLeasingInquiry };
})();
